const BasicDetails = () => {
    return (
        <div className="vision-card">
            <div id="basic">

                <h3 className="table-section-heading">
                    BASIC DETAILS
                </h3>

                <div className="table-section-wrap">
                    <table className="table-section basic-table">

                        <tbody>

                            <tr>
                                <td>NAME OF THE SCHOOL</td>
                                <td>NAV JEEVAN MISSION SCHOOL</td>
                                <td>SCHOOL CODE</td>
                                <td>71065</td>
                            </tr>

                            <tr>
                                <td>COMPLETE ADDRESS WITH PIN CODE</td>
                                <td>SONAULI ROAD, ANANDNAGAR, MAHARAJGANJ, PIN:273155</td>
                                <td>AFFILIATION CODE</td>
                                <td>2132348</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL NAME & QUALIFICATION</td>
                                <td>SHAJI LOUIS</td>
                                <td>PRINCIPAL'S CONTACT NUMBER</td>
                                <td>7525013411</td>
                            </tr>

                            <tr>
                                <td>SCHOOL EMAIL ID</td>
                                <td>navjeevananandnagar@gmail.com</td>
                                <td>SCHOOL'S CONTACT NUMBER</td>
                                <td>91-7525013411</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S WEBSITE</td>
                                <td>www.navjeevananandnagar.in</td>
                                <td>SCHOOL'S FAX NUMBER</td>
                                <td>0000000000</td>
                            </tr>

                            <tr>
                                <td>LANDMARK NEAR SCHOOL</td>
                                <td>Police Station Anandnagar</td>
                                <td>YEAR OF ESTABLISHMENT</td>
                                <td>2005</td>
                            </tr>

                            <tr>
                                <td>AFFILIATION VALIDITY</td>
                                <td>2016 TO 2019</td>
                                <td>AFFILIATION STATUS</td>
                                <td>PROVISIONAL</td>
                            </tr>

                            <tr>
                                <td>NAME OF THE TRUST / SOCIETY / COMPANY REGISTERED WITH</td>
                                <td>A.C. George Memorial Educational Society</td>
                                <td>REGISTRATION DATE</td>
                                <td>25/11/2010</td>
                            </tr>

                            <tr>
                                <td>SOCIETY REGISTRATION NUMBER</td>
                                <td>2296/2015-16</td>
                                <td>REGISTRATION VALIDITY</td>
                                <td>25/11/2020</td>
                            </tr>

                            <tr>
                                <td>NOC ISSUING AUTHORITY</td>
                                <td>Joint Director Education</td>
                                <td>NOC ISSUING DATE</td>
                                <td>27/06/2014</td>
                            </tr>

                            <tr>
                                <td>NO OBJECTION CERTIFICATE</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\noc\55584.PDF)</td>
                                <td>NON PROPRIETY CHARACTER AFFIDAVIT /NON PROFIT COMPANY AFFIDAVIT</td>
                                <td>VIEW (PdfHandler .aspx? FileName=G:\cbse\2016\schdetails\a#idavit\55584.PDF)</td>
                            </tr>

                        </tbody>

                    </table>
                </div>

            </div>
        </div>

    );
};

export default BasicDetails;